import { Route, Routes } from "react-router";
import { Layout } from "./components/layout/Layout";
import { NotFound } from "./routes/404";
import { Cart } from "./routes/Cart";
import { Category } from "./routes/Category";
import { Confirmation } from "./routes/Confirmation";
import { Delivery } from "./routes/Delivery";
import { Favorites } from "./routes/Favorites";
import { Home } from "./routes/Home";
import { Order } from "./routes/Order";
import { Orders } from "./routes/Orders";
import { Product } from "./routes/Product";
import { Recap } from "./routes/Recap";
import { SLUG_CONFIRMATION, SLUG_ORDER } from "./styles/slugs";
import {
  SLUG_CART,
  SLUG_CATEGORY,
  SLUG_PRODUCT,
  SLUG_FAVORITES,
  SLUG_ORDERS,
  SLUG_DELIVERY,
  SLUG_RECAP,
} from "./styles/slugs";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path={""} element={<Home />} />
          <Route path={`${SLUG_CART}/*`} element={<Cart />} />
          <Route path={`${SLUG_DELIVERY}/*`} element={<Delivery />} />
          <Route path={`${SLUG_RECAP}/*`} element={<Recap />} />
          <Route path={`${SLUG_CONFIRMATION}/*`} element={<Confirmation />} />
          <Route path={`${SLUG_FAVORITES}/*`} element={<Favorites />} />
          <Route path={`${SLUG_ORDERS}/*`} element={<Orders />} />
          <Route path={`${SLUG_ORDER}/:orderId/*`} element={<Order />} />
          <Route
            path={`${SLUG_CATEGORY}/:categorySlug/*`}
            element={<Category />}
          />
          <Route
            path={`${SLUG_PRODUCT}/:productSlug/*`}
            element={<Product />}
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
